import {
  GET_CUSTOMER_TABLE_DATA,
  GET_EQUIPMENT_DATA,
  SET_CUSTOMER_TABLE_STATUS,
  SET_EQUIPMENT_DATA_STATUS,
  RESET_EQUIPMENT_DATA,
  SET_SUBMIT_REQUEST_STATUS,
} from '../helpers/types';

const INITIAL_STATE = {
  customerDataArr: [],
  isLoading: false,
  listCount: null,
  failText: '',
  failTextEquipment: '',
  equipmentData: [],
  listCountEquipment: null,
  isEquipmentLoading: false,
  requestSubmitted: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMER_TABLE_DATA:
      return {
        ...state,
        customerDataArr: action.payload.data,
        isLoading: false,
        listCount: action.payload.listCount,
        failText: '',
      };
    case GET_EQUIPMENT_DATA:
      return {
        ...state,
        equipmentData: action.payload.data,
        isEquipmentLoading: false,
        listCountEquipment: action.payload.listCount,
        failTextEquipment: action.payload.failTextEquipment,
      };
    case SET_CUSTOMER_TABLE_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_EQUIPMENT_DATA_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_SUBMIT_REQUEST_STATUS:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_EQUIPMENT_DATA:
      return {
        ...state,
        equipmentData: [],
        failText: '',
      };
    default:
      return state;
  }
};
